import { useMemo } from 'react';
import { useFetch } from '../../../../../hooks';
import { useSort } from '../../../../../hooks/useSort';
import { sortArray } from '../../../../../utilities/sortArray';
import { getVisits } from '../../../../../api';
import { extractShortId } from '../../../../url-sortener/utils/urlUtils';
import type { http_VisitItem } from '../../../../../services/url-shortener';

export const useCampaignVisitsDetails = (
  demoUrl: string | null,
  enabled: boolean = true,
  excludeCountries?: string[]
) => {
  const shortId = extractShortId(demoUrl);
  const shouldSkip = !enabled || !demoUrl || !shortId;

  const {
    data: visitResponse,
    loading,
    error,
  } = useFetch(
    async () => {
      if (!shortId) {
        return null;
      }
      return await getVisits(shortId, excludeCountries);
    },
    [shortId, enabled, excludeCountries],
    {
      skip: shouldSkip,
      initialData: null,
      onError: false,
    }
  );

  const { sort, setSort } = useSort<'country' | 'visited_at'>(undefined, false);

  const visits = useMemo(() => {
    return (visitResponse?.visits || []) as http_VisitItem[];
  }, [visitResponse?.visits]);

  const sortedVisits = useMemo(() => {
    if (!visits || !visits.length) return visits || [];
    return sortArray(visits, sort);
  }, [visits, sort]);

  const handleSort = (newSort: string) => {
    setSort(newSort as 'country' | 'visited_at');
  };

  return {
    visits: sortedVisits,
    totalCount: visitResponse?.total_count || 0,
    loading,
    error: !!error,
    sort,
    onSort: handleSort,
  };
};
